import { render, staticRenderFns } from "./zbgg.vue?vue&type=template&id=4c30c5d4&"
import script from "./zbgg.vue?vue&type=script&lang=js&"
export * from "./zbgg.vue?vue&type=script&lang=js&"
import style0 from "./zbgg.vue?vue&type=style&index=0&id=4c30c5d4&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports